// Refund Request *****************************************************************************
// pathname: /v1/job-operation/{jobSlug}/refund-request
// ************************************************************************************************
import {
  useSwrMutationApi,
} from 'src/hooks/useSwrApi';
import { bjToast } from '@components/common';
import { useTranslation } from 'next-i18next';


/**
 * @description SWR mutation: POST for refund process
 * @param locale
 * @param jobSlug - parameters for the current refunded job
 */
export const useSwrJobRefundRequest = (jobSlug : string, locale = 'ro') => {
  // SWR mutation: fetch order
  // ********************************************

  const { t } = useTranslation('common');


  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<object, undefined>({
    url: `/v1/job-operation/${jobSlug}/refund-request`,
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: () => {
        bjToast.success(t('global.label.success'));
      },
      onError: (newError) => {
        if (newError.errors[0].message) {
          bjToast.error(newError.errors[0].message);
        }
      },
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
